<div class="pontos" [ngClass]="definirClassePontos()" (click)="onClick()">
  <p class="pontos__voce__tem" [hidden]="minimo && !exibirVoceTem">Você tem</p>

  <div class="pontos__valor">
    <img class="pontos__icone" src="assets/images/icons/cacau_moeda.png" />

    <p class="pontos__cacaus">
      {{ pontuacao }}
      <span [hidden]="minimo"> {{ pontuacao > 1 ? "Cacaus" : "Cacau" }} </span>
    </p>
  </div>
</div>